import React from 'react';
import './QuoteBox.css'

interface QuoteBoxProps {
    quote: string;
    author: string;
    source?: string; // Optional source, e.g., book title, website
}

const QuoteBox: React.FC<QuoteBoxProps> = ({ quote, author, source }) => {
    return (
        <figure className="quote-box"> {/* Use <figure> for semantic grouping */}
            <blockquote>{quote}</blockquote>
            <figcaption>
                &mdash; {author}
                {source && <cite> ({source})</cite>}
            </figcaption>
        </figure>
    );
};

export default QuoteBox;